import React from "react";
import { Box, CardContent, Skeleton } from "@mui/material";
import { StandardCard } from "../../../../components/Cards";

export const KeyMetricsSkeleton: React.FC = () => {
  return (
    <StandardCard>
      <CardContent>
        <Skeleton variant="text" width={120} height={32} sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[1, 2, 3, 4].map((index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={40} height={24} />
            </Box>
          ))}
        </Box>
      </CardContent>
    </StandardCard>
  );
};
